import React, { FunctionComponent, useState } from 'react';
import {
  ProgressStepContent,
  IProgressStepContentProps
} from './progress-step-content/progress-step-content';
import { Text, ITextProps } from '../text/text';
import { ProgressStepItem } from './progress-step-item/progress-step-item';
import styles from './progress-steps.module.scss';

export interface IProgressStepsProps {
  progressStepsItems: ITextProps[];
  progressStepsContent: IProgressStepContentProps[];
}

export const ProgressSteps: FunctionComponent<IProgressStepsProps> = ({
  progressStepsItems,
  progressStepsContent
}) => {
  const [activeStep, setActiveStep] = useState<number>(0);

  const changeStepHandler = (event: React.MouseEvent<HTMLElement>): void => {
    const elem = event.currentTarget as HTMLDivElement;
    const index = elem.dataset.index || 0;

    setActiveStep(+index);
  };

  return (
    <div className={styles.container}>
      <div className={styles.stepItemsWrapper}>
        {progressStepsItems.map((text, i) => (
          <ProgressStepItem
            key={i}
            index={i}
            isActive={activeStep === i}
            stepItemIsDone={activeStep > i}
            changeStep={changeStepHandler}
          >
            <Text {...text} />
          </ProgressStepItem>
        ))}
      </div>
      {progressStepsContent.map(
        (item, i) =>
          i === activeStep && <ProgressStepContent {...item} key={i} />
      )}
    </div>
  );
};
